import { render, staticRenderFns } from "./beneficiary-door-to-door.vue?vue&type=template&id=b30e3158&"
import script from "./beneficiary-door-to-door.vue?vue&type=script&lang=js&"
export * from "./beneficiary-door-to-door.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports